

































































































const sizeMap: {[size: string]: number} = {
  xxsmall: 8,
  xsmall: 10,
  small: 14,
  medium: 18,
  xmedium: 20,
  large: 24,
  mlarge:29,
  xlarge: 36,
  xxlarge: 48,
};

import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon, IconConfig } from '../sw-icon';
import { CSSStyleOptions } from '../common-types';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwIconButton extends SwExtendedVue {
  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  @Prop({ type: [Object, String], required: true })
  icon: IconConfig | string | 'divider';

  @Prop({ type: [String, Number], default: 29 })
  buttonSize: string | number;

  @Prop({ type: String })
  color: string | undefined;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  noBorder: boolean;

  isHover: boolean = false;

  get effectiveIconConfig(): IconConfig {
    let useConfig: IconConfig | null = null;

    if (this.isDivider) {
      useConfig = { name: 'diamond', size: 6 };
    } else if (typeof this.icon === 'string') {
      useConfig = { name: this.icon };
    } else {
      useConfig = this.icon;
    }

    return Object.assign(
      {
        size: 16,
      },
      useConfig,
    );
  }

  get isDivider(): boolean {
    return this.icon === 'divider';
  }

  get specifiedButtonSizeNumeric() : number  {
    if (typeof this.buttonSize === 'number') {
      return this.buttonSize;
    }
    return sizeMap[this.buttonSize] || sizeMap['mLarge'];
  }

  get specifiedIconSizeNumeric(): number {
    const iconSize = this.effectiveIconConfig['size'];
    if (typeof iconSize === 'number') {
      return iconSize;
    }
    return iconSize ? sizeMap[iconSize] : sizeMap['medium'];
  }

  get effectiveButtonConfig(): CSSStyleOptions {
    const style: CSSStyleOptions = {};
    const specifiedButtonSize = this.specifiedButtonSizeNumeric;
    const iconSize = this.specifiedIconSizeNumeric;
    const proportion = iconSize / specifiedButtonSize;
    const maxProportion = 20 / 29;

    if (proportion > maxProportion) {
      style.width = `${iconSize / maxProportion}px`;
      style.height = `${iconSize / maxProportion}px`;
    } else {
      style.width = `${specifiedButtonSize}px`;
      style.height = `${specifiedButtonSize}px`;
    }
    if (this.color) {
      style.color = this.isHover ? null : this.color;
    }
    return style;
  }

  onMouseEnter() {
    this.isHover = true;
  }
  onMouseLeave() {
    this.isHover = false;
  }
}
